<template lang="pug">
  div
    v-dropdown(
      ref="dropdown"
      width-auto
      position-right)
      v-btn(icon)
        i.i-util-more
      v-card(
        elevated
        slot="content")
          .app-settings
            h3.app-settings__title {{ 'app.menu' | translate }}
            .app-settings__section
              v-btn.mb-2(
                ghost
                @click="openSettingsUserModal")
                  v-icon(
                    font-size="1"
                    icon="cog"
                    position-left)
                  span.app-settings__btn-text {{ 'app.settings' | translate }}
              v-btn(
                ghost
                @click="openInfoModal")
                  v-icon(
                    font-size="1"
                    icon="info-circle"
                    position-left)
                  span.app-settings__btn-text {{ 'app.about_app' | translate }}
            h3.app-settings__title {{ 'base.lang' | translate }}
            .app-settings__section
              lang-switcher
            v-btn(
              ghost
              danger
              @click="logout")
                span.app-settings__btn-icon
                  font-awesome-icon(
                    size="sm"
                    icon="sign-out-alt")
                span.app-settings__btn-text {{ 'base.logout' | translate }}
    v-dialog(
      max-width="350"
      v-model="modals.showSettingsUser")
      settings-user-modal(@close="modals.showSettingsUser = false")
    v-dialog(
      max-width="300"
      v-model="modals.showAppInfoModal")
      app-info(@close="modals.showAppInfoModal = false")
</template>

<script>
import SettingsUserModal from '../user-profile/modals/SettingsUserModal'
import AppInfo from '../modals/AppInfo'
import LangSwitcher from './LangSwitcher'

export default {
  name: 'AppSettings',

  components: {
    SettingsUserModal,
    AppInfo,
    LangSwitcher
  },

  data: () => ({
    modals: {
      showSettingsUser: false,
      showAppInfoModal: false
    }
  }),

  methods: {
    openSettingsUserModal () {
      this.modals.showSettingsUser = true
      this.$refs.dropdown.closeDropdown()
    },

    openInfoModal () {
      this.modals.showAppInfoModal = true
      this.$refs.dropdown.closeDropdown()
    },

    logout () {
      this.$store.dispatch('account/logout')
      this.$router.push('/auth')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/sass/abstracts/_variables.scss';

  .app-settings {
    padding: 2rem;
    min-width: 19rem;

    &__title {
      font-size: 1.5rem;
      line-height: 1.8rem;
      font-weight: 500;
      color: $color-gray;
      margin-bottom: 1.5rem;
    }

    &__section {
      position: relative;
      margin-bottom: 1.5rem;
      padding-bottom: 1.5rem;
      border-bottom: 1px solid $color-gray-light-2;
    }

    &__btn-icon {
      font-size: 1.8rem;
      margin-right: 1.3rem;
    }

    &__btn-text {
      font-size: 1.5rem;
      line-height: 1.8rem;
    }
  }
</style>
